export default "__VITE_ASSET__2ad70a35__"